import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Suggerimento } from '../models/suggerimento';
import { SuggerimentoService } from '../services/suggerimento.service';

export class BaseEditForm {
  form: FormGroup;
  public dialogRef: MatDialogRef<any>;

  async edit() {

    this.form.markAllAsTouched(); // mark all form controls and groups as touched to trigger display of validation errors.

    if (this.form?.valid) {
      let res = await this.handleSuccessfulSubmit();
      this.dialogRef?.close(res ?? this.form.value);
    }

    else {
      this.warnNotValid();
    }
  }

  protected warnNotValid() {
    this['toast']?.warning('Il form non è valido.');
    console.error(this.form?.errors);
    console.log(findInvalidControls(this.form))
  }

  //dummy successful submit method
  handleSuccessfulSubmit(): Promise<any> {
    return Promise.resolve(undefined);
  };

}
function findInvalidControls(f: FormGroup) {
  if (!f)
    return [];
  const invalid = [];
  const controls = f.controls;
  for (const name in controls) {
    if (controls[name].invalid) {
      invalid.push(name);
    }
  }
  return invalid;
}


@Component({
  template: '',
})
export class EditFormConSuggerimenti extends BaseEditForm implements OnInit {
  suggerimenti: Suggerimento[];

  constructor(private suggerimentiService: SuggerimentoService,) {
    super();
  }

  async ngOnInit() {
    this.mappa_suggerimenti = {};

    this.suggerimenti = await this.suggerimentiService.getAll();
    this.buildSuggerimentiMap();
  }

  mappa_suggerimenti: { [key: string]: Suggerimento[] } = {};

  buildSuggerimentiMap() {
    for (let suggerimento of this.suggerimenti) {
      this.mappa_suggerimenti[suggerimento.campo] = this.mappa_suggerimenti[suggerimento.campo] || [];
      this.mappa_suggerimenti[suggerimento.campo].push(suggerimento);
    }
    for (let key in this.mappa_suggerimenti) {
      this.mappa_suggerimenti[key].sort((s1, s2) => s1.ordinale - s2.ordinale);
    }
  }

  suggerimenti_per_control(form_control_name): Suggerimento[] {
    if (!this.mappa_suggerimenti)
      return [];
    return this.mappa_suggerimenti[form_control_name] ?? [];

  }

  addTextToControl(control_name: string, text) {
    let newVal = text;
    let control = this.form.controls[control_name];

    if (control.value) {
      newVal = control.value + "\n" + text;
    }
    control.patchValue(newVal);
  }

}